import React from 'react';
// import { Link } from 'react-router-dom';

const Dashboard = () => {
    return(
        <section className="container">
            <h1 className="large text-primary">
                Coming Soon
            </h1>
            {/* <div className="dash-buttons">
                <Link to="/edit-profile" className="btn btn-light">
                    <i className="fas fa-user-circle text-primary"></i> 
                    Edit Profile
                </Link>
                <Link to="#showCategoryModal" className="btn btn-light"
                ><i className="fab fa-black-tie text-primary"></i> Add Category</Link>
            </div>
            <div class="profile-exp p-2">
                <h2 class="text-primary">Profile</h2>
                <div>
                    <h3 class="text-dark text-light">Name</h3>
                    <p>Oct 2011 - Current</p>
                    <p><strong>Position: </strong>Senior Developer</p>
                    <p>
                    <strong>Description: </strong>Lorem ipsum dolor sit amet
                    consectetur adipisicing elit. Dignissimos placeat, dolorum ullam
                    ipsam, sapiente suscipit dicta eius velit amet aspernatur
                    asperiores modi quidem expedita fugit.
                    </p>
                </div>
                <div>
                    <h3 class="text-dark">Sun Microsystems</h3>
                    <p>Nov 2004 - Nov 2011</p>
                    <p><strong>Position: </strong>Systems Admin</p>
                    <p>
                    <strong>Description: </strong>Lorem ipsum dolor sit amet
                    consectetur adipisicing elit. Dignissimos placeat, dolorum ullam
                    ipsam, sapiente suscipit dicta eius velit amet aspernatur
                    asperiores modi quidem expedita fugit.
                    </p>
                </div>
            </div> */}
        </section>
    )
}
  
export default Dashboard;
